import Vue from 'vue'
import VueLocalStorage from 'vue-ls'

import ProductsAPI from '@/api/products'
import PropertiesAPI from '@/api/properties'
import ShippingAPI from '@/api/shipping'
import VelaEasyAPI from '@/api/velaeasy'
import PaymentAPI from '@/api/payment'
import CustomFormAPI from '@/api/custom_form'
import ContactFormAPI from '@/api/contact_form'
import OrderAPI from '@/api/order'
import KpaymentAPI from '@/api/kpayment'
import ShapppyAPI from '@/api/shappy'
import getSymbolFromCurrency from 'currency-symbol-map'
import { Settings } from 'luxon'
import { Base64 } from 'js-base64'

Vue.use(VueLocalStorage, {
  namespace: 'rpcart__'
})
export const Cart = new Vue({
  data () {
    return {
      system: '',
      shappy: {
        customToken: '',
        appId: '0',
        channelId: '0',
        firstname: '',
        lastname: '',
        email: '',
        mobile: '',
        member: 0,
        domain: '',
        profileId: '',
        channelName: ''
      },
      velaeasy: {
        domain: ''
      },
      color: {
        primaryMain: '',
        primarySub: '',
        secondaryMain: '',
        secondarySub: ''
      },
      token: {
        public: null,
        member: null
      },
      member: {
        status: 0,
        id: '',
        info: {
          shipping: {},
          billing: {},
          sameAddress: 0
        },
        countryCode: 'TH'
      },
      products: this.$ls.get('products', []),
      address: this.$ls.get('address', {
        shipping: {
          email: '',
          countryId: 'TH',
          country: 'Thailand',
          provinceId: '',
          province: '',
          districtId: '',
          district: '',
          subDistrictId: '',
          subDistrict: ''
        },
        billing: {
          email: '',
          countryId: 'TH',
          country: 'Thailand',
          provinceId: '',
          province: '',
          districtId: '',
          district: '',
          subDistrictId: '',
          subDistrict: ''
        },
        same_shipping: true,
        edited: false,
        profileId: '0'
      }),
      payment: this.$ls.get('payment', {
        type: '',
        value: ''
      }),
      paymentRegistered: [],
      currency: {
        type: '',
        code: '',
        display: '',
        position: '',
        name_th: '',
        name_en: ''
      },
      newShipping: {},
      shippingRegion: {},
      shippingStorage: {},
      hasCountry: false,
      newShippingRegion: false,
      shipping_item_select: {
        shipping_price: 0,
        selected: false
      },
      properties: {
        cart_text: {
          cart_view_page: '',
          thank_you_page: ''
        }
      },
      features: {
        paypal: '1',
        omise: '1',
        kpayment: '1'
      },
      confirmStatus: false,
      locale: 'en',
      orderId: this.$ls.get('order_id', ''),
      orderData: {
        status: 'none',
        type: 'cart'
      },
      orderResult: {
        status: false,
        message: '',
        order_id: 0,
        totalPrice: 0,
        orderManagement: 0,
        errorCode: 0
      },
      paymentSlipResult: {
        status: false 
      },
      confirmCustomForm: false,
      form: {},
      globalFont: '',
      multiLanguageId: '',
      gclid: this.$ls.get('gclid', ''),
      regex: {
        validation: {
          email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          phone: /^([+,\-,0-9]){7,15}$/
        }
      },
      contactForm: {
        fields: [],
        form: {}
      },
      submitContactForm: {
        loading: false
      },
      validate: {
        orderCustomForm: true,
        shipping: true
      },
      uploadStatus: false,
      contactFormColor: {
        buttonBackground: '',
        buttonText: ''
      },
      isOutOfStock: false,
      consent: {
        status: false,
        value: ''
      },
      defaultPolicy: '',
      pointspot: {
        status: 0,
        loginStatus: 0,
        businessToken: '',
        businessCode: '',
        usePoint: false,
        usePointAmount: 0,
        discountAmount: 0,
        receivePointAmount: 0,
        receivePhoneNumber: '',
        validatePointSpotNumber: false,
        receivePointID: 0,
        quotaExceed: false,
        profile : {
          mobile_number: ''
        }
      },
      province_list: {},
      all_province_list: [],
      cartPulse: false,
      cartPulseTimeout: false,
      productOrderNote: this.$ls.get('products_note', {}),
      changeQuantityTimeout: {},
      changeNoteTimeout: {},
      district_list: {},
      sub_district_list: {}
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          thankYouForYourOrder: 'Thank you for your order.',
          productQuantityIsNotEnough: 'Product quantity is not enough.',
          errorOccuredTryAgainLater: 'Error occured! Please try again later.',
          paypal: {
            UNABLE_TO_COMPLETE_TRANSACTION: 'Unable to complete transaction',
            INVALID_PAYMENT_METHOD: 'Invalid payment method',
            PAYER_CANNOT_PAY: 'Payer cannot pay',
            CANNOT_PAY_THIS_PAYEE: 'Cannot pay this payee',
            REDIRECT_REQUIRED: 'Redirect required',
            PAYEE_FILTER_RESTRICTIONS: 'Payee filter restrictions',
            AUTHORIZATION_FAILED: 'Merchant authentication failed'
          },
          kpayment: {
            AUTHORIZATION_FAILED: 'Merchant authentication failed'
          },
          free: 'Free',
          insufficientProducts: 'This product is out of stock.',
          productPriceChanges: 'Some of product price have been changed.',
          discountPriceChanges: 'Discounts have been changed.',
          discount: 'Discount'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          thankYouForYourOrder: 'ขอบคุณสำหรับการสั่งซื้อ',
          productQuantityIsNotEnough: 'สินค้าไม่เพียงพอ',
          errorOccuredTryAgainLater: 'เกิดข้อผิดพลาด! โปรดลองใหม่ภายหลัง',
          paypal: {
            UNABLE_TO_COMPLETE_TRANSACTION: 'การทำรายการไม่สำเร็จ',
            INVALID_PAYMENT_METHOD: 'วิธีการชำระเงินไม่ถุกต้อง',
            PAYER_CANNOT_PAY: 'ไม่สามารถชำระเงินได้',
            CANNOT_PAY_THIS_PAYEE: 'ไม่สามารถชำระเงินได้',
            REDIRECT_REQUIRED: 'Redirect required',
            PAYEE_FILTER_RESTRICTIONS: 'Payee filter restrictions',
            AUTHORIZATION_FAILED: 'ร้านค้ายืนยันตัวตนไม่สำเร็จ'
          },
          kpayment: {
            AUTHORIZATION_FAILED: 'ร้านค้ายืนยันตัวตนไม่สำเร็จ'
          },
          free: 'ฟรี',
          insufficientProducts: 'สินค้าหมด',
          productPriceChanges: 'ราคาของสินค้าบางรายการมีการเปลี่ยนแปลง',
          discountPriceChanges: 'ส่วนลดมีการเปลี่ยนแปลง',
          discount: 'ส่วนลด'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          thankYouForYourOrder: 'Cám ơn bạn đã đặt hàng.',
          productQuantityIsNotEnough: 'Không đủ số lượng sản phẩm.',
          errorOccuredTryAgainLater: 'Xảy ra lỗi! Vui lòng thử lại sau',
          paypal: {
            UNABLE_TO_COMPLETE_TRANSACTION: 'Không thể hoàn tất thanh toán',
            INVALID_PAYMENT_METHOD: 'Phương thức thanh toán không tồn tại',
            PAYER_CANNOT_PAY: 'Không thể thanh toán',
            CANNOT_PAY_THIS_PAYEE: 'Không thể thanh toán',
            REDIRECT_REQUIRED: 'Yêu cầu chuyển tiếp',
            PAYEE_FILTER_RESTRICTIONS: 'Người nhận lọc hạn chế',
            AUTHORIZATION_FAILED: 'Merchant authentication failed'
          },
          kpayment: {
            AUTHORIZATION_FAILED: 'Merchant authentication failed'
          },
          free: 'Miễn phí',
          insufficientProducts: 'Sản phẩm hiện đang hết hàng. ',
          productPriceChanges: 'Some of product price have been changed.',
          discountPriceChanges: 'Discounts have been changed.',
          discount: 'Discount'
        }
      }
    },
    totalProductPrice () {
      return this.products.reduce((a, b) => {
        let checkedPrice = this.checkProductStepPrices(b)

        return a + (parseFloat(checkedPrice.price) * parseFloat(b.quantity))
      }, 0)
    },
    totalProductQuantity () {
      return this.products.reduce((a, b) => {
        return a + parseInt(b.quantity)
      }, 0)
    },
    totalProductPriceWithDiscount () {
      if (this.pointspot.status === 1 && this.pointspot.usePoint === true) {
        return this.totalProductPrice - this.pointspot.discountAmount
      } else {
        return this.totalProductPrice
      }
    },
    totalProductPriceWithDiscountAndShipping () {
      return parseFloat(this.totalProductPriceWithDiscount) + parseFloat(this.shipping_item_select.shipping_price)
    },
    totalPrice () {
      let shippingPrice = 0
      if (typeof this.shipping_item_select.shipping_price !== 'undefined' &&
          this.shipping_item_select.shipping_price !== '-' &&
          this.shipping_item_select.shipping_price !== 'free') {
        shippingPrice = parseFloat(this.shipping_item_select.shipping_price)
      }
      if (this.pointspot.status === 1 && this.pointspot.usePoint === true) {
        return this.totalProductPriceWithDiscount + shippingPrice
      } else {
        return this.totalProductPrice + shippingPrice
      }
    },
    totalWeight () {
      return this.products.reduce((a, b) => {
        return a + (parseInt(b.weight) * parseInt(b.quantity))
      }, 0)
    }
  },
  methods: {
    concatImagePath (imagePath, width, height) {
      return process.env.IMAGE_SERVICE_URL + '/image/250x0/' + imagePath
    },
    setOrderId (orderId) {
      this.orderId = orderId
    },
    getOrderId () {
      return this.orderId
    },
    setToken (publicToken) {
      this.token.public = publicToken
    },
    reloadProduct () {
      return new Promise (async (resolve, reject) => {
        const oldProduct =  this.$ls.get('products', [])
        let productCount = oldProduct.length
        for (let i = 0; i < productCount; i++) {
          this.deleteProduct(oldProduct[i].sku, true)
     
          if (await this.reloadProductAPI(oldProduct[i].sku, oldProduct[i].quantity) === 'deleted_product' &&
            this.orderId !== ''
          ) {
            await OrderAPI.deleteOrderDetail({
              publicToken: this.token.public,
              orderId: this.orderId,
              sku: oldProduct[i].sku
            })
          }
        }
        resolve(true)
      })
    },
    addToCart (callback, sku, quantity) {
      this.syncCartProducts()
      let productIndex = this.checkDuplicate(decodeURIComponent(sku))
      if (productIndex >= 0) {
        callback(this.addQuantity(productIndex, quantity))
      } else {
        this.getProductAPI(callback, sku, quantity)
      }
    },
    clearCartProducts () {
      return new Promise((resolve) => {
        this.products = []
        this.setLocalStorage('products')
        resolve(true)
      })
    },
    clearOrderId () {
      this.setOrderId('')
      this.setLocalStorage('order_id')
    },
    async addOrderToCart (sku, quantity) {
      return await this.getProductPromiseAPI(sku, quantity)
    },
    async addQuantity (index, quantity) {
      this.syncCartProducts()
      this.products[index].quantity = parseInt(this.products[index].quantity) + quantity
      this.products[index].quantityHis = this.products[index].quantity
      let checkedPrice = this.checkProductStepPrices (this.products[index])
      this.products[index].price = checkedPrice.price
      this.products[index].price_strike = checkedPrice.priceStrike

      this.setLocalStorage('products')
      if (this.orderId !== '') {
        await OrderAPI.updateOrderDetail({
          publicToken: this.token.public,
          order_id: this.orderId,
          sku: this.products[index].sku,
          quantity: quantity
        })
      }
      return true
    },
    getProductAPI (callback, sku, quantity) {
      let param = {
        publicToken: this.token.public,
        sku: sku,
        languageId: this.multiLanguageId
      }
      ProductsAPI.getProduct(async response => {
        if (response.data.data) {
          if (this.orderId != '') {
            await OrderAPI.addOrderDetail({
              order_id: this.orderId,
              product_id: response.data.data.id,
              publicToken: this.token.public,
              sku: response.data.data.sku,
              name: response.data.data.product_name,
              variants: response.data.data.attribute,
              image_path: response.data.data.image_path,
              quantity: quantity,
              languageId: this.multiLanguageId
            })
          }
          this.setProduct(response.data.data, quantity)
          callback(true)
        }
      }, param)
    },
    getProductPromiseAPI (sku, quantity) {
      return new Promise((resolve) => {
        let param = {
          publicToken: this.token.public,
          sku: sku,
          languageId: this.multiLanguageId
        }
        ProductsAPI.getProduct(async (response) => {
          if (response.data.status == 'success' && response.data.data) {
            this.setProduct(response.data.data, quantity)
            resolve(response.data.data)
          } else {
            resolve('deleted_product')
          }
        }, param)
      })
    },
    getOrderAPI (orderId) {
      return new Promise((resolve) => {
        let params = {
          orderId: orderId,
          publicToken: this.token.public,
          languageId: this.multiLanguageId
        }

        OrderAPI.getOrderLink(response => {
          if (response.data.data) {
            resolve(response.data.data)
          }
        }, params)
      })
    },
    reloadProductAPI (sku, quantity) {
      return new Promise((resolve, reject) => {
        let param = {
          publicToken: this.token.public,
          sku: sku,
          languageId: this.multiLanguageId
        }
        ProductsAPI.getProduct(response => {
          if (response.data.status == 'success' && response.data.data) {
            this.setProduct(response.data.data, quantity)
            resolve(true)
          } else {
            resolve('deleted_product')
          }
        }, param)
      })
    },
    syncCartProducts () {
      this.products = this.$ls.get('products', [])
    },
    checkProductStepPrices (product) {
      let price = product.price
      let priceStrike = ''

      if (product.pricing_model === '2' && product.product_step_prices && product.product_step_prices.length > 0) {
        if (product.quantity >= parseInt(product.product_step_prices[product.product_step_prices.length - 1].range_start) && parseInt(product.product_step_prices[product.product_step_prices.length - 1].range_end) === -1) {
          if (product.product_step_prices[product.product_step_prices.length - 1].member_price != null && this.member.status) {
            price = parseFloat(product.product_step_prices[product.product_step_prices.length - 1].member_price)
            priceStrike = parseFloat(product.product_step_prices[product.product_step_prices.length - 1].normal_price)
          } else if (product.product_step_prices[product.product_step_prices.length - 1].special_price != null) {
            price = parseFloat(product.product_step_prices[product.product_step_prices.length - 1].special_price)
            priceStrike = parseFloat(product.product_step_prices[product.product_step_prices.length - 1].normal_price)
          } else {
            price = parseFloat(product.product_step_prices[product.product_step_prices.length - 1].normal_price)
          }
        } else {
          product.product_step_prices.forEach((item) => {
            if (product.quantity >= parseInt(item.range_start) && product.quantity <= parseInt(item.range_end)) {
              if (item.member_price != null && this.member.status) {
                price = parseFloat(item.member_price)
                priceStrike = parseFloat(item.normal_price)
              } else if (item.special_price != null) {
                price = parseFloat(item.special_price)
                priceStrike = parseFloat(item.normal_price)
              } else {
                price = parseFloat(item.normal_price)
              }
            }
          })
        }
      } else {
        if (product.price || product.price === 0) {
          price = parseFloat(product.price)
        } else {
          if (product.member_price != null && this.member.status) {
            price = parseFloat(product.member_price)
            priceStrike = parseFloat(product.normal_price)
          } else if (product.special_price != null) {
            price = parseFloat(product.special_price)
            priceStrike = parseFloat(product.normal_price)
          } else {
            price = parseFloat(product.normal_price)
          }
        }
      }

      return {
        price: price,
        priceStrike: priceStrike
      }
    },
    setProduct (product, quantity) {
      let price = 0
      let priceStrike = ''

      product.quantity = quantity
      let checkedPrice = this.checkProductStepPrices(product)
      price = checkedPrice.price
      priceStrike = checkedPrice.priceStrike

      let note = this.productOrderNote[product.sku]

      if (!note && product.product_note) {
        note = product.product_note
        this.productOrderNote[product.sku] = note
      }

      this.products.push({
        id: product.id,
        sku: product.sku,
        name: product.product_name,
        variants: product.attribute,
        price: price,
        price_strike: priceStrike,
        image_path: product.image_path,
        image_arr: product.image_arr,
        quantity: quantity,
        quantityHis: quantity,
        use_stock: product.use_stock,
        stock: product.stock,
        weight: product.weight,
        note: note,
        variant_image_path: product.variant_image_path,
        variant_image_arr: product.variant_image_arr,
        pricing_model: product.pricing_model,
        product_step_prices: product.product_step_prices
      })

      this.setLocalStorage('products')
    },
    checkDuplicate (sku) {
      let productIndex = this.products.findIndex(product => {
        if (String(product.sku) === String(sku)) {
          return true
        }
      })

      return productIndex
    },
    getFeatures () {
      return this.features
    },
    getProperties () {
      return this.properties
    },
    getProducts () {
      return this.products
    },
    async deleteProduct (sku, reload) {
      let productIndex = this.checkDuplicate(sku)
      if (productIndex >= 0) {
        this.deleteProductFromCart(productIndex)
      }

      if (this.orderId !== '' && reload === false) {
        await OrderAPI.deleteOrderDetail({
          publicToken: this.token.public,
          orderId: this.orderId,
          sku: sku
        })
      }
    },
    async deleteProductFromCart (index) {
      this.productOrderNote[this.products[index].sku] = ''
      this.products.splice(index, 1)
      this.setLocalStorage('products')
      this.setLocalStorage('products_note')
    },
    changeQuantity (sku, quantity) {
      let productIndex = this.checkDuplicate(sku)
      if (productIndex >= 0) {
        if (quantity < 0) {
          quantity = 0
        }
        this.products[productIndex].quantity = quantity
        let checkedPrice = this.checkProductStepPrices (this.products[productIndex])
        this.products[productIndex].price = checkedPrice.price
        this.products[productIndex].price_strike = checkedPrice.priceStrike

        this.setLocalStorage('products')

        if (this.orderId !== '') {
          clearTimeout(this.changeQuantityTimeout[sku])
          this.changeQuantityTimeout[sku] = setTimeout(() => {
            OrderAPI.updateOrderDetail({
              publicToken: this.token.public,
              order_id: this.orderId,
              sku: sku,
              quantity: quantity
            })
          }, 1000)
        }
      }
    },
    setAddress (address, addressType) {
      if (addressType === 'shipping') {
        this.address.shipping = address
      } else {
        this.address.billing = address
      }

      this.address.edited = true
      this.setLocalStorage('address')
    },
    setAddressEdited (edited) {
      this.address.edited = edited
    },
    getAddress () {
      return this.address
    },
    getConsent () {
      return this.consent
    },
    getConsentApi (component) {
      let param = {
        task: 'get_consent'
      }
      if (this.system === 'ShopShappy') {
        ShapppyAPI.getConsentForShappy(result => {
          if (this.locale === 'vi' &&
            result.data.data.consent.includes('consent-container') &&
            component === 'cartForm'  
          ) {
            result.data.data.consent = result.data.data.consent.replace('<a href="javascript:void(0)"', '<br /><a href="javascript:void(0)"')
          }

          this.consent = {
            value: result.data.data.consent.replace('text-consent', 'vue-text-consent').replace('popup-policy', 'vue-popup-policy'),
            status: true
          }
          
          if (this.consent.value.includes('popup-policy')) {
            this.getDefaultPolicyApi()
          }
        }, {
          token: this.token.public,
          language: this.locale
        })
      } else {
        VelaEasyAPI.getConsent(result => {
          const consentBase64 = result.data.consent
          let consentDecoded = Base64.decode(consentBase64)

          if (this.locale === 'vi' &&
            consentDecoded.includes('consent-container') &&
            component === 'cartForm'
          ) {
            consentDecoded = consentDecoded.replace('<a href=', '<br /><a href=')
          }

          this.consent = {
            value: consentDecoded.replace('text-consent', 'vue-text-consent').replace('popup-policy', 'vue-popup-policy'),
            status: true
          }

          if (this.consent.value.includes('popup-policy')) {
            this.getDefaultPolicyApi()
          }
        }, param)
      }
    },
    getDefaultPolicy () {
      return this.defaultPolicy
    },
    getDefaultPolicyApi () {
      if (this.system === 'ShopShappy') {
        ShapppyAPI.getDefaultPolicyForShappy(result => {
          this.defaultPolicy = result.data.data.policy
        }, {
          token: this.token.public,
          language: this.locale
        })
      } else {
        VelaEasyAPI.getDefaultPolicy(result => {
          this.defaultPolicy = result.data
        })
      }
    },
    getMemberToken (callback) {
      return new Promise((resolve, reject) => {
        if (this.member.status && this.system === 'Velaeasy') {
          let param = {
            task: 'get_member_token'
          }
          VelaEasyAPI.getMemberToken(result => {
            this.token.member = result.data.member_token
            resolve({
              member_token: this.token.member,
              member_id: this.member.id
            })
          }, param)
        } else if (this.system === 'ShopShappy') {
          resolve({
            member_token: this.shappy.member,
            member_id: 0
          })
        } else {
          resolve(false)
        }
      })
    },
    order (callback) {
      if (this.member.status && this.system === 'Velaeasy') {
        let param = {
          task: 'get_member_token'
        }
        VelaEasyAPI.getMemberToken(result => {
          this.token.member = result.data.member_token
          this.orderConfirm(callback)
        }, param)
      } else {
        this.orderConfirm(callback)
      }
    },
    async orderConfirm (callback) {
      try {
        if (this.form.form.status === '1') {
          this.form.detail.forEach(element => {
            if (element.value === 'form-default-value') {
              element.value = ''
            }
          })
        } else {
          this.form.form.status = '0'
          this.form.detail = {}
        }
        let payment_method_str = this.payment.type
        if (this.payment.description != '' && this.payment.description != null && this.payment.description != 'null') {
          payment_method_str = payment_method_str + ' (' + this.payment.description + ')'
        }
        let param = {
          token: this.token.public,
          products: this.products,
          address: this.address,
          // remark: this.address.shipping.remark,
          system: this.system,
          shipping_type_id: {
            shipping_item_id: this.shipping_item_select.id,
            name: this.shipping_item_select.name,
            price: this.shipping_item_select.shipping_price
          },
          // shipping_type_id: this.shipping.selected.id,
          payment_method: payment_method_str,
          card_token: this.payment.value,
          member_token: this.token.member,
          member_id: this.member.id,
          language: this.locale,
          form: this.form.detail,
          gclid: this.getGclId(),
          velaeasy_domain: this.velaeasy.domain,
          total_price: this.totalPrice,
          order_type: this.orderData.type
        }
  
        if (this.orderId !== '') {
          param.order_id = this.orderId
        }
  
        if (this.system === 'ShopShappy') {
          param.member_token = this.shappy.member
          param.custom_token = this.shappy.customToken
          param.app_id = this.shappy.appId
          param.channel_id = this.shappy.channelId
          param.shappy_domain = this.shappy.domain
          param.channel_name = this.shappy.channelName
        }
        if (this.pointspot.status === 1) {
          if (this.pointspot.receivePointID && this.pointspot.receivePointID > 0) {
            param.pointspot_receive_id = this.pointspot.receivePointID
            param.pointspot_receive_point = this.pointspot.receivePointAmount
          } 
  
          if (this.pointspot.loginStatus === 1 && this.pointspot.usePoint === true) {
            param.pointspot_confirm_token = ''
            param.pointspot_discount_amount = this.pointspot.discountAmount
            param.pointspot_id = this.pointspot.profile.member_badge_code
          }
        }
        let isClearLocalStorage = true

        const checkUsingPoints = await this.checkUsePointSpot()

        if (checkUsingPoints !== true) {
          throw new Error('pointspot_calculate_point_error')
        }
  
        ProductsAPI.order(result => {
          let response = {
            payment: '',
            orderId: result.data.order_id,
            orderEmail: param.address.billing.email ? param.address.billing.email: param.address.shipping.email,
            publicToken: this.token.public,
            url: ''
          }

          if (result.status == 'success') {
            this.pointSpotRedeem()
            if (this.payment.type == 'omise') {
              if (result.data.omise_response === 'successful' || !result.data.omise_response) {
                this.setOrderResult({
                  status: true,
                  orderId: result.data.order_id,
                  message: this.t.thankYouForYourOrder,
                  totalPrice: this.totalPrice
                })
                let expireTime = 60 * 60 * 1000 * 24 * 7 * 4 // 1 month
                this.$ls.set('order', {totalPrice: this.totalPrice}, expireTime)
              } else if (result.data.omise_response === 'error') {
                let message
                if (result.data.omise_error_message === 'Amount must be greater than or equal to 2000 (thb subunits)') {
                  message = 'less_than_lower_price_omise'
                } else {
                  message = result.data.omise_error_code
                }
                this.setOrderResult({
                  status: false,
                  orderId: result.data.order_id,
                  message: message,
                  totalPrice: this.totalPrice
                })
                let expireTime = 60 * 60 * 1000 * 24 * 7 * 4 // 1 month
                this.$ls.set('order', {totalPrice: this.totalPrice}, expireTime)
              } else if (result.data.omise_response === 'pending') {
                response.payment = 'omise'
                response.url = result.data.omise_auth_uri
                let expireTime = 60 * 60 * 1000 * 24 * 7 * 4 // 1 month
                this.$ls.set('order', {totalPrice: this.totalPrice}, expireTime)
              }
            } else if (this.payment.type == 'kbank_card') {
              response.payment = 'kbank_card'
  
              if (param.total_price === 0) {
                this.setOrderResult({
                  status: true,
                  orderId: result.data.order_id,
                  message: this.t.thankYouForYourOrder,
                  totalPrice: param.total_price,
                  orderManagement: result.order_management
                })
              } else {
                isClearLocalStorage = false
              }
            } else if (this.payment.type == 'kbank_qr') {
              response.payment = 'kbank_qr'
  
              if (param.total_price === 0) {
                this.setOrderResult({
                  status: true,
                  orderId: result.data.order_id,
                  message: this.t.thankYouForYourOrder,
                  totalPrice: param.total_price,
                  orderManagement: result.order_management
                })
              } else {
                isClearLocalStorage = false
              }
            } else { // IsTransfer
              response.payment = 'transfer'
              this.setOrderResult({
                status: true,
                orderId: result.data.order_id,
                message: this.t.thankYouForYourOrder,
                totalPrice: param.total_price,
                orderManagement: result.order_management
              })
            }
          } else {
            if (result.data.code === '04') {
              this.setOrderResult({
                status: false,
                orderId: null,
                message: this.t.productQuantityIsNotEnough,
                errorCode: result.data.code
              })
              isClearLocalStorage = false
            } else if (result.data.code === '11') {
              this.setOrderResult({
                status: false,
                orderId: null,
                message: this.t.productPriceChanges,
                errorCode: result.data.code
              })
              isClearLocalStorage = false
            } else {
              this.setOrderResult({
                status: false,
                orderId: null,
                message: this.t.errorOccuredTryAgainLater,
                errorCode: result.data.code
              })
            }
          }
  
          if (isClearLocalStorage === true) {
            this.clearLocalStorage()
          }

          callback(response)
        }, param)
      } catch (error) {
        let errorMessage = ''

        if (error.message === 'pointspot_calculate_point_error') {
          errorMessage = this.t.discountPriceChanges
        } else {
          errorMessage = this.t.errorOccuredTryAgainLater
        }

        this.setOrderResult({
          status: false,
          orderId: null,
          message: errorMessage,
          errorCode: '03'
        })

        callback({})
      }
    },
    setOrderResult (param) {
      this.orderResult.status = param.status
      this.orderResult.orderId = param.orderId
      this.orderResult.message = param.message
      this.orderResult.totalPrice = param.totalPrice
      this.orderResult.orderManagement = param.orderManagement
      this.orderResult.errorCode = param.errorCode
    },
    setPaypalOrderResult (status, orderId, totalPrice, failureReason, errorCode) {
      this.orderResult.status = status
      this.orderResult.orderId = orderId
      this.orderResult.errorCode = errorCode

      // Error 01 is authentication failed
      // Error 02 is payment failure
      // Error 03 is other errors

      if (failureReason && failureReason != '') {
        this.orderResult.errorCode = '02'

        if (failureReason === 'UNABLE_TO_COMPLETE_TRANSACTION') {
          this.orderResult.message = this.t.paypal.UNABLE_TO_COMPLETE_TRANSACTION
        } else if (failureReason === 'INVALID_PAYMENT_METHOD') {
          this.orderResult.message = this.t.paypal.INVALID_PAYMENT_METHOD
        } else if (failureReason === 'PAYER_CANNOT_PAY') {
          this.orderResult.message = this.t.paypal.PAYER_CANNOT_PAY
        } else if (failureReason === 'CANNOT_PAY_THIS_PAYEE') {
          this.orderResult.message = this.t.paypal.CANNOT_PAY_THIS_PAYEE
        } else if (failureReason === 'REDIRECT_REQUIRED') {
          this.orderResult.message = this.t.paypal.REDIRECT_REQUIRED
        } else if (failureReason === 'PAYEE_FILTER_RESTRICTIONS') {
          this.orderResult.message = this.t.paypal.PAYEE_FILTER_RESTRICTIONS
        } else if (failureReason === 'pointspot_calculate_point_error') {
          this.orderResult.errorCode = '03'
          this.orderResult.message = this.t.discountPriceChanges
        } else {
          this.orderResult.errorCode = '03'
          this.orderResult.message = this.t.errorOccuredTryAgainLater
        }
      } else {
        if (status === true) {
          this.orderResult.message = this.t.thankYouForYourOrder
          this.orderResult.totalPrice = totalPrice
        } else {
          if (errorCode === '11') {
            this.orderResult.message = this.t.productPriceChanges
          } else if (errorCode === '01') {
            this.orderResult.errorCode = '01'
            this.orderResult.message = this.t.paypal.AUTHORIZATION_FAILED
          } else {
            this.orderResult.message = this.t.productQuantityIsNotEnough
          }
        }
      }
    },
    setKpaymentOrderResult (status, orderId, errorCode) {
      this.orderResult.status = status
      this.orderResult.orderId = orderId
      this.orderResult.errorCode = errorCode

      if (errorCode === '11') {
        this.orderResult.message = this.t.productPriceChanges
      } else if (errorCode === 'authentication_failure') {
        this.orderResult.errorCode = '01'
        this.orderResult.message = this.t.kpayment.AUTHORIZATION_FAILED
      } else {
        this.orderResult.errorCode = '03'
        this.orderResult.message = this.t.errorOccuredTryAgainLater
      }
    },
    getOrderResult () {
      return this.orderResult
    },
    setNumberFormat (value) {
      if (value === '') return ''
      let price = parseFloat(value)

      return price.toLocaleString('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2
      })
    },
    setNumberFormatNoDecimal (value) {
      if (value === '') return ''
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setLocalStorage (ls) {
      let expireTime = 60 * 60 * 1000 * 24 * 7 * 4 // 1 month
      if (ls === 'products') {
        this.$ls.set('products', this.products, expireTime)
      } else if (ls === 'address') {
        this.$ls.set('address', this.address, expireTime)
      } else if (ls === 'gclid') {
        this.$ls.set('gclid', this.gclid, expireTime)
      } else if (ls === 'member') {
        this.$ls.set('member', this.member, expireTime)
      } else if (ls === 'products_note') {
        this.$ls.set('products_note', this.productOrderNote, expireTime)
      } else if (ls === 'order_id') {
        this.$ls.set('order_id', this.orderId, expireTime)
      }
    },
    async clearLocalStorage () {
      let dummyAddress = this.$ls.get('address', {
        shipping: {
          email: '',
          countryId: 'TH',
          country: 'Thailand'
        },
        billing: {
          email: '',
          countryId: 'TH',
          country: 'Thailand'
        },
        same_shipping: true,
        edited: false
      })
      if (this.pointspot.status === 1) {
        this.pointspot.profile = {}
        this.pointspot.confirmToken = ''
        this.pointspot.loginStatus = 0
        this.pointspot.receivePointID = 0
        this.pointspot.receivePhoneNumber = ''
        this.pointspot.usePoint = false
        this.pointspot.usePointAmount = 0
        this.pointspot.discountAmount = 0
      }
      this.$ls.clear()
      dummyAddress.edited = false
      dummyAddress.profileId = this.shappy.profileId
      if (this.system === 'ShopShappy') {
        this.$ls.set('address', dummyAddress)
      }
      this.products = []
      this.orderId = ''
      this.address = dummyAddress
      this.$ls.set('gclid', '')
      this.gclid = ''
      this.shipping_item_select = {
        shipping_price: 0,
        selected: false
      }
    },
    getPropertiesAPI () {
      PropertiesAPI.getProperties(response => {
        this.properties = response.data.data.properties
      }, {
        token: this.token.public
      })
    },
    getVelaeasyFeaturesAPI () {
      PropertiesAPI.getFeatures(response => {
        this.features = response.data.data.feature[0]
      }, {
        token: this.token.public
      })
    },
    getCurrencyAPI () {
      let param = {
        token: this.token.public
      }
      PropertiesAPI.getCurrency(response => {
        this.currency.type = response.data.data.currency.type
        this.currency.code = response.data.data.currency.code
        this.currency.display = response.data.data.currency.display
        this.currency.position = response.data.data.currency.position
        this.currency.name_th = response.data.data.currency.name_th
        this.currency.name_en = response.data.data.currency.name_en
      }, param)
    },
    getCurrency (value) {
      if (value === '-') {
        return value
      } else {
        var text = ''
        if (this.currency.display === 'iso') {
          text = this.currency.code
        } else if (this.currency.display === 'symbol') {
          text = getSymbolFromCurrency(this.currency.code)
        } else {
          if (this.getLocale() === 'th') {
            text = this.currency.name_th
          } else {
            text = this.currency.name_en
          }
        }
        if (this.currency.position === 'prefix') {
          return text + ' ' + value
        } else {
          return value + ' ' + text
        }
      }
    },
    getCurrencyCode () {
      return this.currency.code
    },
    getShippingStorage () {
      return this.shippingStorage
    },
    setShippingStorage (value) {
      this.shippingStorage = value
    },
    getShippingItemSelect () {
      return this.shipping_item_select
    },
    setShippingItemSelect (value) {
      this.shipping_item_select = value
    },
    setPayment (param) {
      this.payment.type = param.type
      this.payment.value = param.value
      this.payment.slip = param.slip
      this.payment.description = param.description
      this.setLocalStorage('payment')
    },
    getPayment () {
      return this.payment
    },
    setConfirmAddress (status) {
      this.confirmStatus = status
    },
    getConfirmAddress () {
      return this.confirmStatus
    },
    setLocale (locale) {
      this.locale = locale
      Settings.defaultLocale = locale
    },
    getLocale () {
      return this.locale
    },
    getCardToken (card, callback) {
      PaymentAPI.getOmisePublicKey(result => {
        this.createTokenOmise(card, result.data.public_key, callback)
      },
      {
        token: this.token.public
      })
    },
    createTokenOmise (card, omisePublicKey, callback) {
      let cardExpire = card.expire.value.split('/')
      let omiseCard = {
        name: card.name.value,
        number: card.number.value,
        expiration_month: cardExpire[0],
        expiration_year: cardExpire[1],
        security_code: card.cvc.value
      }
      // eslint-disable-next-line
      Omise.setPublicKey(omisePublicKey)
      // eslint-disable-next-line
      Omise.createToken('card', omiseCard, (statusCode, response) => {
        if (response.object == 'error' || !response.card.security_code_check) {
          let messageError = 'omise_secure_error'
          if (response.object == 'error') {
            messageError = 'omise_error'
          }
          let messageCode = response.code
          if (!response.code) {
            messageCode = 'omise_secure_error'
          }
          callback({
            status: false,
            data: messageError,
            code: messageCode,
            message: response.message
          })
        } else {
          callback({
            status: true,
            data: response.id
          })
        }
      })
    },
    setMember (member, memberId) {
      this.member = {
        status: member,
        id: memberId
      }
    },
    getMemberAPI () {
      return new Promise((resolve) => {
        if (this.system === 'Velaeasy') {
          if (this.member.status && this.member.id !== '' && this.address.edited === false) {
            let param = {
              task: 'get_member_info',
              memberId: this.member.id
            }
  
            VelaEasyAPI.getMemberInfo(result => {
              this.address.shipping = {
                'first_name': this.address.shipping.first_name ? this.address.shipping.first_name : ( result.data.member_info.shipping_address.first_name ? result.data.member_info.shipping_address.first_name : '' ),
                'last_name': this.address.shipping.last_name ? this.address.shipping.last_name : (result.data.member_info.shipping_address.last_name ? result.data.member_info.shipping_address.last_name : '' ),
                'email': this.address.shipping.email ? this.address.shipping.email : (result.data.member_info.shipping_address.email ? result.data.member_info.shipping_address.email : '' ),
                'phone': this.address.shipping.phone ? this.address.shipping.phone : (result.data.member_info.shipping_address.phone ? result.data.member_info.shipping_address.phone : '' ),
                'address': this.address.shipping.address ? this.address.shipping.address : (result.data.member_info.shipping_address.address ? result.data.member_info.shipping_address.address : '' ),
                'address2': this.address.shipping.address2 ? this.address.shipping.address2 : (result.data.member_info.shipping_address.address_line2 ? result.data.member_info.shipping_address.address_line2 : '' ),
                'country': this.address.shipping.country ? this.address.shipping.country : '',
                'countryId': this.address.shipping.countryId ? this.address.shipping.countryId : (result.data.member_info.shipping_address.country ? result.data.member_info.shipping_address.country : '' ),
                'province': this.address.shipping.province ? this.address.shipping.province : (result.data.member_info.shipping_address.province ? result.data.member_info.shipping_address.province : '' ),
                'province_id': this.address.shipping.province_id ? this.address.shipping.province_id : (result.data.member_info.shipping_address.province_id ? result.data.member_info.shipping_address.province_id : '' ),
                'provinceId': this.address.shipping.provinceId ? this.address.shipping.provinceId : '',
                'district':  this.address.shipping.district ? this.address.shipping.district : '',
                'districtId': this.address.shipping.districtId ? this.address.shipping.districtId : (result.data.member_info.shipping_address.district_id ? result.data.member_info.shipping_address.district_id : '' ),
                'subDistrict':  this.address.shipping.subDistrict ? this.address.shipping.subDistrict : '',
                'subDistrictId': this.address.shipping.subDistrictId ? this.address.shipping.subDistrictId : (result.data.member_info.shipping_address.sub_district_id ? result.data.member_info.shipping_address.sub_district_id : '' ),
                'postcode': this.address.shipping.postcode ? this.address.shipping.postcode : (result.data.member_info.shipping_address.zipcode ? result.data.member_info.shipping_address.zipcode : '' ),
              }
              this.address.billing = {
                'first_name': this.address.billing.first_name ? this.address.billing.first_name : (result.data.member_info.billing_address.first_name ? result.data.member_info.billing_address.first_name : '' ),
                'last_name': this.address.billing.last_name ? this.address.billing.last_name : (result.data.member_info.billing_address.last_name ? result.data.member_info.billing_address.last_name : '' ),
                'email': this.address.billing.email ? this.address.billing.email : (result.data.member_info.billing_address.email ? result.data.member_info.billing_address.email : '' ),
                'phone': this.address.billing.phone ? this.address.billing.phone : (result.data.member_info.billing_address.phone ? result.data.member_info.billing_address.phone : '' ),
                'address': this.address.billing.address ? this.address.billing.address : (result.data.member_info.billing_address.address ? result.data.member_info.billing_address.address : '' ),
                'address2': this.address.billing.address2 ? this.address.billing.address2 : (result.data.member_info.billing_address.address_line2 ? result.data.member_info.billing_address.address_line2 : '' ),
                'country': this.address.billing.country ? this.address.billing.country : '',
                'countryId': this.address.billing.countryId ? this.address.billing.countryId : (result.data.member_info.billing_address.country ? result.data.member_info.billing_address.country : '' ),
                'province': this.address.billing.province ? this.address.billing.province : (result.data.member_info.billing_address.province ? result.data.member_info.billing_address.province : '' ),
                'province_id': this.address.billing.province_id ? this.address.billing.province_id : (result.data.member_info.billing_address.province_id ? result.data.member_info.billing_address.province_id : '' ),
                'provinceId': this.address.billing.provinceId ? this.address.billing.provinceId : '',
                'district':  this.address.billing.district ? this.address.billing.district : '',
                'districtId': this.address.billing.districtId ? this.address.billing.districtId : (result.data.member_info.billing_address.district_id ? result.data.member_info.billing_address.district_id : '' ),
                'subDistrict':  this.address.billing.subDistrict ? this.address.billing.subDistrict : '',
                'subDistrictId': this.address.billing.subDistrictId ? this.address.billing.subDistrictId : (result.data.member_info.billing_address.sub_district_id ? result.data.member_info.billing_address.sub_district_id : '' ),
                'postcode': this.address.billing.postcode ? this.address.billing.postcode : (result.data.member_info.billing_address.zipcode ? result.data.member_info.billing_address.zipcode : '' ),
              }
              this.address.same_shipping = result.data.member_info.same_address
              if(this.address.same_shipping == true){
                this.address.billing.countryId = "TH";
              }
              this.member.countryCode = result.data.member_info.shipping_address.country
            }, param)
          }
        } else if (this.system === 'ShopShappy') {
          let lsAddress = this.$ls.get('address', {
            profileId: '0'
          })
          if (this.address.edited === false && this.shappy.profileId !== lsAddress.profileId) {
            this.address.shipping = {
              'first_name': this.shappy.firstname ? this.shappy.firstname : '',
              'last_name': this.shappy.lastname ? this.shappy.lastname : '',
              'email': this.shappy.email ? this.shappy.email : '',
              'phone': this.shappy.mobile ? this.shappy.mobile : '',
              'countryId': 'TH',
              'district':  '',
              'subDistrict':  '',
              'province': ''
            }
            this.address.billing = {
              'first_name': this.shappy.firstname ? this.shappy.firstname : '',
              'last_name': this.shappy.lastname ? this.shappy.lastname : '',
              'email': this.shappy.email ? this.shappy.email : '',
              'phone': this.shappy.mobile ? this.shappy.mobile : '',
              'countryId': 'TH',
              'district':  '',
              'subDistrict':  '',
              'province': ''
            }
            this.member.status = this.shappy.member
            this.address.same_shipping = true
            this.member.countryCode = 'TH'
          }
        }

        resolve(true)
      })
    },
    getPaymentAPI () {
      PaymentAPI.getPaymentStatus(result => {
        this.paymentRegistered = result.data
      },
      {
        token: this.token.public
      })
    },
    getPaymentRegistered () {
      return this.paymentRegistered
    },
    getPaypalCreatePaymentUrl () {
      return PaymentAPI.getPaypalCreatePaymentUrl({
        token: this.token.public
      })
    },
    getPaypalExecutePaymentUrl () {
      return PaymentAPI.getPaypalExecutePaymentUrl({
        token: this.token.public
      })
    },
    getOrderUrl () {
      return ProductsAPI.getOrderUrl({
        token: this.token.public,
        system: this.system
      })
    },
    getMemberUrl () {
      return VelaEasyAPI.getMemberUrl()
    },
    setMemberToken (memberToken) {
      this.token.member = memberToken
    },
    getOrderParams () {
      if (this.form.form.status === '1') {
        this.form.detail.forEach(element => {
          if (element.value === 'form-default-value') {
            element.value = ''
          }
        })
      } else {
        this.form.form.status = '0'
        this.form.detail = {}
      }
      let param = {
        token: this.token.public,
        products: JSON.stringify(this.products),
        address: JSON.stringify(this.address),
        system: this.system,
        shipping_type_id: {
          shipping_item_id: this.shipping_item_select.id,
          name: this.shipping_item_select.name,
          price: this.shipping_item_select.shipping_price
        },
        // shipping_type_id: this.shipping.selected.id,
        payment_method: this.payment.type,
        card_token: this.payment.value,
        member_token: this.token.member,
        member_id: this.member.id,
        language: this.locale,
        form: this.form.detail,
        gclid: this.getGclId(),
        velaeasy_domain: this.velaeasy.domain,
        order_type: this.orderData.type,
        total_price: this.totalPrice,
      }

      if (this.orderId !== '') {
        param.order_id = this.orderId
      }

      if (this.system === 'ShopShappy') {
        param.member_token = this.shappy.member
        param.custom_token = this.shappy.customToken
        param.app_id = this.shappy.appId
        param.channel_id = this.shappy.channelId
        param.shappy_domain = this.shappy.domain
        param.channel_name = this.shappy.channelName
      }
      if (this.pointspot.status === 1) {
        if (this.pointspot.receivePointID && this.pointspot.receivePointID > 0) {
          param.pointspot_receive_id = this.pointspot.receivePointID
          param.pointspot_receive_point = this.pointspot.receivePointAmount
        }

        if (this.pointspot.loginStatus === 1 && this.pointspot.usePoint === true) {
          param.pointspot_confirm_token = ''
          param.pointspot_discount_amount = this.pointspot.discountAmount
          param.pointspot_id = this.pointspot.profile.member_badge_code
        }
      }
      return param
    },
    setColor (primaryMainColor, primarySubColor, secondaryMainColor, secondarySubColor, linkColor) {
      this.color = {
        primaryMain: primaryMainColor,
        primarySub: primarySubColor,
        secondaryMain: secondaryMainColor,
        secondarySub: secondarySubColor,
        link: linkColor
      }
    },
    getColor () {
      return this.color
    },
    getCustomFormAPI () {
      CustomFormAPI.getCustomForm(result => {
        this.form = result.data
      },
      {
        token: this.token.public
      })
    },
    getCustomForm () {
      return this.form
    },
    setConfirmCustomForm (status) {
      this.confirmCustomForm = status
    },
    getConfirmCustomForm () {
      if (this.form.form.status === '0') {
        return true
      } else if (this.form.form.status === null) {
        return true
      } else {
        return this.confirmCustomForm
      }
    },
    getContactForm () {
      this.getContactFormAPI().then(result => {
        this.contactForm.fields = result.detail
        this.contactForm.form = result.forms
      })
    },
    getContactFormAPI () {
      return new Promise((resolve, reject) => {
        ContactFormAPI.getContactForm({
          token: this.token.public
        }, result => {
          resolve(result.data.data)
        })
      })
    },
    submitContactFormAPI (params) {
      return new Promise((resolve, reject) => {
        if (this.system === 'ShopShappy') {
          
          ContactFormAPI.submitShappyContactForm({
            token: this.token.public,
            formData: params
          }, result => {
            if (result.data.status === 'success') {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        } else {
          ContactFormAPI.submitContactForm({
            token: this.token.public,
            formData: params
          }, result => {
            if (result.data.status === 'success') {
              resolve(true)
            } else {
              resolve(false)
            }
          })
        }
      })
    },
    setShappyProps (customToken, appId, channelId, firstname, lastname, email, mobile, member, domain, profileId, channelName) {
      this.shappy.customToken = customToken
      this.shappy.appId = appId
      this.shappy.channelId = channelId
      this.shappy.firstname = firstname
      this.shappy.lastname = lastname
      this.shappy.email = email
      this.shappy.mobile = mobile
      this.shappy.member = member
      this.shappy.domain = domain
      this.shappy.profileId = profileId
      this.shappy.channelName = channelName
    },
    getShappy () {
      return this.shappy
    },
    setVelaeasyDomain (velaeasyDomain) {
      velaeasyDomain = velaeasyDomain.replace('http://', '')
      velaeasyDomain = velaeasyDomain.replace('https://', '')
      this.velaeasy.domain = velaeasyDomain
    },
    getVelaeasyDomain () {
      return this.velaeasy.domain
    },
    setSystem (system) {
      this.system = system
    },
    getSystem () {
      return this.system
    },
    validateFormDetail () {
      let result = true
      for (let index = 0; index < this.form.detail.length; index++) {
        if ((this.form.detail[index].value === '' ||
          (!this.form.detail[index].value || this.form.detail[index].value === 'form-default-value')) &&
          this.form.detail[index].required === '1'
        ) {
          this.form.detail[index].status = true
          result = false
        } else {
          this.form.detail[index].status = false
        }

        this.$set(this.form.detail, index, this.form.detail[index])
      }

      return result
    },
    setGclId (gclid) {
      let oldGclid = this.getGclId()
      if (gclid !== '' && gclid !== oldGclid) {
        this.gclid = gclid
        this.setLocalStorage('gclid')
      }
    },
    getGclId () {
      return this.$ls.get('gclid')
    },
    setGlobalFont (globalFont) {
      this.globalFont = globalFont
    },
    getGlobalFont () {
      return this.globalFont
    },
    getMultiLanguage () {
      return this.multiLanguageId
    },
    setMultiLanguage (multiLanguageId) {
      this.multiLanguageId = multiLanguageId
    },
    uploadFileAPI (formData) {
      return new Promise((resolve, reject) => {
        let param = {'token': this.token.public, 'formData': formData}
        CustomFormAPI.uploadFile(response => {
          resolve(response)
        }, param)
      })
    },
    getUploadStatus () {
      return this.uploadStatus
    },
    setUploadStatus (value) {
      this.uploadStatus = value
    },
    getShippingAllRegionCountryAPI () {
      return new Promise((resolve, reject) => {
        let param = {
          'token': this.token.public,
          'language': this.locale,
          'member': this.member.status,
          'country': this.member.countryCode}
        ShippingAPI.getShippingAllRegionCountry(result => {
          this.setShippingAllRegionCountry(result.data.data)
          resolve(result.data)
        }, param)
      })
    },
    getAllProvinceList () {
      return new Promise((resolve, reject) => {
        try {
          if (this.all_province_list.length === 0) {
            let param = {
              'token': this.token.public,
              'language': this.locale,
              'member': this.member.status,
              'country': this.member.countryCode}
            ShippingAPI.getProvinceList(result => {
              this.setAllProvinceList(result.data.data)
              resolve(result.data.data)
            }, param)
          } else {
            resolve(this.all_province_list)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    setShippingAllRegionCountry (value) {
      this.newShipping = value
    },
    getAllProvince () {
      return this.all_province_list
    },
    setAllProvinceList (value) {
      this.all_province_list = value
    },
    setProvinceList (value) {
      this.province_list = value
    },
    getProvinceItem () {
      return this.province_list
    },
    getShippingAllRegionCountry () {
      return this.newShipping
    },
    getShippingRegion () {
      return this.shippingRegion
    },
    setShippingRegion (value) {
      this.shippingRegion = value
      this.newShippingRegion = true
    },
    validateShipping () {
      let shipping = this.shippingRegion
      let status = '0'
      shipping.shipping_item.forEach(element => {
        if (element.status === '1') {
          status = '1'
        }
      })
      if (shipping.status === '1' && status === '1') {
        if (this.shipping_item_select.selected !== false) {
          this.validate.shipping = true
        } else {
          this.validate.shipping = false
        }
      } else {
        this.validate.shipping = true
      }
      return this.validate.shipping
    },
    setMemberShipping (member, country) {
      this.member.status = member
      this.member.countryCode = country
    },
    setIsOutOfStock (value) {
      this.isOutOfStock = value
    },
    sendPaymentSlipData (formData) {
      return new Promise((resolve, reject) => {
        let param = {'token': this.token.public, 'formData': formData}
        ProductsAPI.sendPaymentSlipData(result => { 
          if (result.status === 'success') {
            this.setPaymentSlipResult({
              status: true
            })
          } else {
            this.setPaymentSlipResult({
              status: false
            })
          }
          resolve(result)
        }, param)
      })
    },
    getPaymentSlipResult () {
        return this.paymentSlipResult
    },
    setPaymentSlipResult (param) {
        this.paymentSlipResult.status = param.status
    },
    validateOrderCustomForm () {
      let result = true
      this.form.detail.forEach((item, index) => {
        if ((item.value === '' || item.value === 'form-default-value') && item.required === '1') {
          result = false
        }
      })
      Cart.validate.orderCustomForm = result
      return result
    },
    async getPointSpotAPI () {
      return new Promise((resolve, reject) => {
        PropertiesAPI.getPointSpotApp(result => {
          this.pointspot.status = result.data.data.pointspot
          this.pointspot.businessToken = result.data.data.business_token
          this.pointspot.businessCode = result.data.data.business_code
          pstm.initial(this.pointspot.businessCode, this.pointspot.businessToken)

          if (this.pointspot.usePoint === true) {
            this.getPointSpotSendPoints(this.totalProductPrice - this.pointspot.discountAmount)
          } else {
            this.getPointSpotSendPoints(this.totalProductPrice)
          }

          resolve(true)
        },
        {
          token: this.token.public,
          webName: document.location.hostname
        })
      })
    },
    getPointSpot () {
      return this.pointspot
    },
    async getPointSpotProfile () {
      try {
        this.pointspot.profile = await pstm.getProfile()
        this.pointspot.receivePhoneNumber = '0' + this.pointspot.profile.mobile_number
        this.validatePointSpotNumber()
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async getPointSpotBusiness () {
      try {
        this.pointspot.business = await pstm.getBusiness()
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async getPointSpotPoints () {
      try {
        this.$set(this.pointspot, 'point', await pstm.getPoints())
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async calcUsePointSpot () {
      try {
        let res = await pstm.checkRedeemPoints(this.totalProductPrice)

        if (res.error) {
          this.pointspot.quotaExceed = true
        }
        this.pointspot.usePointAmount = res.redeem_points
        this.pointspot.discountAmount = res.redeem_amount
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async checkUsePointSpot () {
      try {
        if (this.pointspot.status === 1
          && this.pointspot.loginStatus === 1
          && this.pointspot.usePoint === true
        ) {
          let res = await pstm.checkRedeemPoints(this.totalProductPrice)
          let points = await pstm.getPoints()

          if (this.pointspot.usePointAmount === res.redeem_points
            && this.pointspot.discountAmount === res.redeem_amount
            && (points.balance - points.pending) >= this.pointspot.usePointAmount
          ) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } catch (error) {
        throw new Error('pointspot_calculate_point_error')
      }
    },
    async getPointSpotAuthState () {
      try {
        this.pointspot.authState = await pstm.getAuthState()
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async getPointSpotSendPoints(price) {
      try {
        if (price > 0) {
          let res =  await pstm.checkSendPoints(price)
          this.pointspot.receivePointAmount = res.points
        } else {
          this.pointspot.receivePointAmount = 0
        }
      } catch (error) {
        this.pointspot.receivePointAmount = 0
      }
    },
    async validatePointSpotNumber() {
      if (this.pointspot.receivePhoneNumber !== '') {
        try {
          let res = await pstm.validate(this.pointspot.receivePhoneNumber)
          if (res.member_badge_code) {
            this.pointspot.receivePointID = res.member_badge_code
            this.pointspot.validatePointSpotNumber = false
          } else {
            this.pointspot.receivePointID = 0
            this.pointspot.validatePointSpotNumber = true
          }
        } catch (error) {
          this.pointspot.receivePointID = 0
          this.pointspot.validatePointSpotNumber = true
        }
        
      } else if (this.pointspot.receivePhoneNumber === '') {
        this.pointspot.receivePointID = 0
        this.pointspot.validatePointSpotNumber = false
      } else {
        this.pointspot.receivePointID = 0
        this.pointspot.validatePointSpotNumber = true
      }
    },
    async confirmPointSpotRedeemToken() {
      try {
        if (this.pointspot.status === 1 && this.pointspot.confirmToken !== '') {
          await pstm.confirmRedeemToken(this.pointspot.confirmToken)
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    async voidPointSpotRedeemToken() {
      try {
        if (this.pointspot.status === 1 && this.pointspot.confirmToken !== '') {
          await pstm.voidRedeemToken(this.pointspot.confirmToken)
        }
      } catch (error) {
        throw new Error(error.message)
      }
    },
    getOrderDetail (orderId) {
      let param = {
        token: this.token.public,
        orderId: orderId
      }
      ProductsAPI.getOrderDetail(response => {
        if (response.data.data) {
          if ( typeof response.data.data.orders !== 'undefined' && response.data.data.orders !== null && response.data.data.orders !== '' ) {
            if (!response.data.data.orders.pointspot_discount_amount) {
              response.data.data.orders.pointspot_discount_amount = 0
            }

            this.setOrderResult({
              status: true,
              orderId: response.data.data.orders.order_id,
              message: '',
              totalPrice: parseFloat(response.data.data.orders.total) - parseFloat(response.data.data.orders.pointspot_discount_amount)
            })
          }
        }
      }, param)
    },
    showCartPulse () {
      this.cartPulse = true
    },
    hideCartPulse () {
      this.clearCartPulseTimeout()
      this.cartPulse = false
    },
    setCartPulseTimeout (func) {
      this.cartPulseTimeout = func
    },
    clearCartPulseTimeout () {
      if (this.cartPulseTimeout) {
        clearTimeout(this.cartPulseTimeout)
      }
    },
    setProductOrderNote (sku, note, index) {
      this.productOrderNote[sku] = note
      this.products[index].note = note

      this.setLocalStorage('products')
      this.setLocalStorage('products_note')

      if (this.orderId !== '') {
        clearTimeout(this.changeNoteTimeout[sku])
        this.changeNoteTimeout[sku] = setTimeout(() => {
          OrderAPI.updateOrderDetailNote({
            publicToken: this.token.public,
            order_id: this.orderId,
            sku: sku,
            note: note
          })
        }, 1000)
      }
    },
    getProductOrderNote () {
      return this.productOrderNote
    },
    clearProductOrderNote () {
      this.productOrderNote = {}
      this.setLocalStorage('products_note')
    },
    async pointSpotRedeem () {
      try {
        let pstmResponse = ''

        if (this.pointspot.status === 1 && this.pointspot.loginStatus === 1 && this.pointspot.usePoint === true) {
          pstmResponse = await pstm.requestRedeemToken(this.pointspot.usePointAmount)
          this.pointspot.confirmToken = pstmResponse.token
          await this.confirmPointSpotRedeemToken()
          await pstm.signout()
        }

        return pstmResponse
      } catch (error) {
        throw new Error(error.message)
      }
    },
    updateOrderAddress () {
      let billingAddress = {}

      if (this.orderId !== '') {
        if (this.address.same_shipping === true) {
          billingAddress = this.address.shipping
        } else {
          billingAddress = this.address.billing
        }
  
        OrderAPI.updateOrderAddress({
          publicToken: this.token.public,
          order_id: this.orderId,
          address: {
            shipping: this.address.shipping,
            billing: billingAddress
          }
        })
      }
    },
    setOrder (params) {
      this.orderData.status = params.order_status
      this.orderData.type = params.order_type
    },
    getOrder () {
      return this.orderData
    },
    checkCompletedOrder () {
      if (this.orderId !== '' && this.orderData.status !== 'new') {
        return true
      } else {
        return false
      }
    },
    getPointSpotDiscount () {
      if (this.pointspot.status === 1 && this.pointspot.loginStatus === 1 && this.pointspot.usePoint === true) {
        return this.pointspot.discountAmount
      } else {
        return 0
      }
    },
    getDistrictList (province_id) {
      return new Promise((resolve, reject) => {
        let param = {
          'token': this.token.public,
          'language': this.locale,
          'member': this.member.status,
          'province_id': province_id,
        }
        ShippingAPI.getDistrictList(result => {
          resolve(result.data.data.district)
        }, param)
      })
    },
    getSubDistrictList (district_id) {
      return new Promise((resolve, reject) => {
        let param = {
          'token': this.token.public,
          'language': this.locale,
          'member': this.member.status,
          'district_id': district_id
        }
        ShippingAPI.getSubDistrictList(result => {
          resolve(result.data.data.sub_district)
        }, param)
      })
    },
    hex2dec (hexString) {
      hexString = (hexString + '').replace(/[^a-f0-9]/gi, '')
      return parseInt(hexString, 16)
    },
    getColorContrast (color1, color2) {
      let R1, G1, B1 = 0
      let R2, G2, B2 = 0 
      if (color1.charAt(0) == 'r') {
        let rgb = color1.replace(/[^\d,.]/g, '').split(',')
        R1 = parseInt(rgb[0])
        G1 = parseInt(rgb[1])
        B1 = parseInt(rgb[2])
      } else {
        R1 = this.hex2dec(color1.substr(1, 2))
        G1 = this.hex2dec(color1.substr(3, 2))
        B1 = this.hex2dec(color1.substr(5, 2))
      }
      
      if (color2.charAt(0) == 'r') {
        let rgb = color2.replace(/[^\d,.]/g, '').split(',')
        R2 = parseInt(rgb[0])
        G2 = parseInt(rgb[1])
        B2 = parseInt(rgb[2])
      } else {
        R2 = this.hex2dec(color2.substr(1, 2))
        G2 = this.hex2dec(color2.substr(3, 2))
        B2 = this.hex2dec(color2.substr(5, 2)) 
      }
       
      let L1 = 0.2126 * Math.pow(R1 / 255, 2.2) + 0.7152 * Math.pow(G1 / 255, 2.2) + 0.0722 * Math.pow(B1 / 255, 2.2)

      let L2 = 0.2126 * Math.pow(R2 / 255, 2.2) + 0.7152 * Math.pow(G2 / 255, 2.2) + 0.0722 * Math.pow(B2 / 255, 2.2)

      let contrastRatio = 0
      if (L1 > L2) {
        contrastRatio = parseFloat((L1 + 0.05) / (L2 + 0.05)).toFixed(1)
      } else {
        contrastRatio = parseFloat((L2 + 0.05) / (L1 + 0.05)).toFixed(1)
      }
      return contrastRatio
    },
    getMemberStorage () {
      return this.$ls.get('member', [])
    },
    setMemberStorage () {
      this.setLocalStorage('member')
    },
    getCurrentMember () {
      return this.member
    },
    clearCurrentAddress () {
      this.address.shipping = {
        'first_name': '',
        'last_name': '',
        'email': '',
        'phone': '',
        'address': '',
        'province': '',
        'countryId':  '',
        'postcode': '',
        'districtId': '',
        'subDistrictId': '',
        'district': '',
        'subDistrict': '',
        'province_id': '',
        'address2': ''
      }
      this.address.billing = {
        'first_name': '',
        'last_name': '',
        'email': '',
        'phone': '',
        'address': '',
        'province': '',
        'countryId':  '',
        'postcode': '',
        'districtId': '',
        'subDistrictId': '',
        'district': '',
        'subDistrict': '',
        'province_id': '',
        'address2': ''
      },
      this.address.same_shipping = true
    },
    createKpaymentOrder (orderId) {
      return new Promise( async (resolve, reject) => {
        try {
          let params = {
            publicToken: this.token.public,
            languageId: this.multiLanguageId,
            orderId: orderId
          }  
          let response = await KpaymentAPI.createOrder(params)

          if (response.status === 'success' && response.data) {
            resolve(response.data)
          } else {
            reject(response.data)
          }
        } catch (e) {
          reject(new Error(e.response.data.data.code))
        }
      })
    },
    getKpaymentSettings () {
      return new Promise(async (resolve, reject) => {
        try {
          let params = {
            publicToken: this.token.public,
            languageId: this.multiLanguageId
          }  
          let response = await KpaymentAPI.getSettings(params)

          if (response.status == 'success') {
            resolve(response.data)
          } else {
            reject(false)
          }
        } catch (e) {
          reject(false)
        }
      })
    },
    getKpaymentCustomer (email) {
      return new Promise(async (resolve, reject) => {
        try {
          let params = {
            publicToken: this.token.public,
            languageId: this.multiLanguageId,
            email: email
          }  
          let response = await KpaymentAPI.getCustomer(params)

          if (response.status == 'success') {
            resolve(response.data)
          } else {
            reject(false)
          }
        } catch (e) {
          reject(false)
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/Cart.js